import React from 'react';

import { Typography } from '../../../DesignSystem';

import { TitleWithTotalWrapper, TotalsWrapper } from './styles';

export interface TitleWithTotalProps {
    title: string;
    total?: number;
}

export function TitleWithTotal({ title, total }: TitleWithTotalProps) {
    const totalMarkup =
        total === undefined ? null : (
            <TotalsWrapper>
                <Typography type="paragraph" size={16}>
                    ({total})
                </Typography>
            </TotalsWrapper>
        );

    return (
        <TitleWithTotalWrapper>
            <Typography type="headline" size={30}>
                {title}
            </Typography>

            {totalMarkup}
        </TitleWithTotalWrapper>
    );
}
